export default __webpack_public_path__ + "static/media/people_hands.9b951a97.jpg";